/* eslint-env browser */

/**
 * FAQ toggle support
 * Used in product page FAQ sections
 *
 * Expands and collapses FAQs on the product pages
 */

function toggleFAQ(faq_id) {
    var faq_box = document.getElementById(faq_id);

    var faq_arrow = faq_box.getElementsByClassName("faq-arrow")[0];
    faq_arrow.classList.toggle("fa-angle-up");
    faq_arrow.classList.toggle("fa-angle-down");

    var faq_content = faq_box.getElementsByClassName("faq-content")[0];
    if (faq_content.style.display === "block") {
        faq_content.style.display = "none";
    } else {
        faq_content.style.display = "block";
    }
}
